"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const immer_1 = __importDefault(require("immer"));
const interfaces_1 = require("../../../../../exports/store/interfaces");
const action_constants_1 = require("../../../../shared/store/action_constants");
exports.theme = (0, immer_1.default)((themeDraft = interfaces_1.ThemeName.Light, action) => {
    if (action.type === action_constants_1.SET_THEME) {
        themeDraft = action.payload;
        return action.payload;
    }
    return themeDraft;
}, interfaces_1.ThemeName.Light);
//# sourceMappingURL=theme.js.map